import { Injectable } from '@angular/core';

import { INSTANT_ESTIMATE_CONFIGS } from './data/instant-estimate-configs';
import {
  buildChartSeries,
  estimateAtIncome,
  validateConfig,
} from './instant-estimate.math';
import {
  InstantEstimateConfig,
  InstantEstimateResult,
} from './instant-estimate.models';

@Injectable({ providedIn: 'root' })
export class InstantEstimateService {
  getConfig(schoolId: string): InstantEstimateConfig | null {
    const key = (schoolId || '').toLowerCase().trim();
    return INSTANT_ESTIMATE_CONFIGS[key] ?? null;
  }

  getValidationErrors(config: InstantEstimateConfig): string[] {
    return validateConfig(config);
  }

  estimate(
    config: InstantEstimateConfig,
    income: number
  ): InstantEstimateResult {
    return estimateAtIncome(config, income);
  }

  getChartSeries(config: InstantEstimateConfig) {
    return buildChartSeries(config);
  }
}
